import actionType from '../actions/actionTypes';
import { HealthProblem, PROJECT_STATUS } from '@nexxt/common/types';
import actionTypes from '../actions/actionTypes';
import { PROJECT_EDIT_MODES } from '../interface/project.interface';
import { TENANT_LEVEL } from '@nexxt/common/types';
import { handleEditMode } from '../utils/project';
import {
    getAccessDevMode,
    getTenantLevel
} from '@nexxt/common/firebase/auth/userDetails';

export interface IProjectReducer {
    isRequesting: boolean;
    isNewProjectCreated: boolean;
    projectError?: any;
    projects: any[];
    newProject: any;
    currentProject: any;
    projectHealth: HealthProblem[];
    projectState: boolean;
    projectPreviewPackageId: number;
    botSettings: any;
    editMode: PROJECT_EDIT_MODES;
    editEnabled: {
        overview: boolean;
        question: boolean;
        audience: boolean;
        settings: boolean;
    };
    packageID: number;
    numOfProjects: number;
    priceType: any;
    currentLockUser: {
        userId: number;
        email: string;
        firstName: string;
        lastName: string;
        isValid: boolean;
    };
}

const initialState: IProjectReducer = {
    isRequesting: false,
    // projectError: "",
    projects: [],
    isNewProjectCreated: false,
    newProject: {},
    currentProject: {},
    projectHealth: [],
    projectState: false,
    projectPreviewPackageId: null,
    botSettings: {},
    editMode: PROJECT_EDIT_MODES.ENABLED,
    editEnabled: {
        overview: true,
        question: true,
        audience: true,
        settings: true
    },
    packageID: 0,
    numOfProjects: 0,
    priceType: {},
    currentLockUser: {
        userId: null,
        email: null,
        firstName: null,
        lastName: null,
        isValid: true
    }
};

export default function (state: IProjectReducer = initialState, action) {
    const getTenantEditMode = () => {
        const tenantLevel = getTenantLevel();
        switch (tenantLevel) {
            case TENANT_LEVEL.SANDBOX:
                return state.currentProject.status === PROJECT_STATUS.REVIEW
                    ? PROJECT_EDIT_MODES.DISABLED
                    : PROJECT_EDIT_MODES.SANBOX_MODE;
            case TENANT_LEVEL.SELF_SERVICE:
                return PROJECT_EDIT_MODES.TEMPLATE_MODE;
            case TENANT_LEVEL.FULL_SERVICE:
                if (getAccessDevMode()) return PROJECT_EDIT_MODES.ENABLED;
                if (state.currentProject.status === PROJECT_STATUS.LIVE)
                    return PROJECT_EDIT_MODES.REPUBLISH;
                if (state.currentProject.status === PROJECT_STATUS.COMPLETE)
                    return PROJECT_EDIT_MODES.DISABLED;
                return PROJECT_EDIT_MODES.ENABLED;
            default:
                return PROJECT_EDIT_MODES.ENABLED;
        }
    };
    const getEditMode = () => {
        if (state.editMode === PROJECT_EDIT_MODES.DISABLED) {
            return state.editMode;
        }
        return getTenantEditMode();
    };
    switch (action.type) {
        case actionType.GET_PROJECTS:
            return {
                ...state,
                numOfProjects: action.payload.data.length || 0,
                projects: action.payload.data || [],
                editMode: getEditMode()
            };
        case actionType.PROJECT_REQUEST:
            return {
                ...state,
                isRequesting: true
            };

        case actionType.PROJECT_REQUEST_ERROR:
            return {
                ...state,
                projectError: action.payload,
                requestingUser: false
            };

        case actionType.PROJECT_FETCH_DATA_SUCCESS:
            return {
                ...state,
                isRequesting: false,
                projects: action.payload
            };
        case actionType.SET_PROJECT:
            const status = action.payload.status || '';
            const editMode = getEditMode();
            return {
                ...state,
                isNewProjectCreated: true,
                newProject: {},
                currentProject: {
                    ...action.payload
                },
                // @DISABLED(If status is not draft, editting project is disabled)
                // editEnabled: status === PROJECT_STATUS.DRAFT || status === PROJECT_STATUS.PAUSED ? PROJECT_EDIT_MODES.DISABLED : status,
                editMode,
                editEnabled: handleEditMode(editMode),
                packageID: action.payload.packageID || 0
            };
        case actionTypes.SET_PROJECT_STATUS:
            const newStatus = action.payload.status;
            return {
                ...state,
                // editEnabled: status === PROJECT_STATUS.DRAFT || status === PROJECT_STATUS.PAUSED ? PROJECT_EDIT_MODES.DISABLED : status,
                editEnabled:
                    newStatus === PROJECT_STATUS.REVIEW
                        ? {
                              overview: false,
                              question: false,
                              audience: false,
                              settings: false
                          }
                        : {
                              overview: true,
                              question: true,
                              audience: true,
                              settings: true
                          },
                currentProject: {
                    ...state.currentProject,
                    status: newStatus
                }
            };
        case actionType.PREVIEW_PROJECT:
            const { projectPreviewPackageId } = action.payload;
            return {
                ...state,
                projectPreviewPackageId
            };
        case actionType.SET_BOT_SETTINGS:
            return {
                ...state,
                isNewProjectCreated: true,
                botSettings: {
                    ...action.payload
                }
            };
        case actionType.CHECK_PROJECT_HEALTH:
            return {
                ...state,
                projectHealth: action.payload
            };
        case actionType.CLEAR_PROJECT_HEALTH:
            return {
                ...state,
                projectHealth: []
            };
        case actionTypes.GET_PRICE:
            const panelSettings = action.payload.data?.panelSettings;
            const currentProject = panelSettings
                ? { ...state.currentProject, panelSettings }
                : state.currentProject;
            delete action.payload.data?.panelSettings;

            return {
                ...state,
                priceType: action.payload.data,
                currentProject
            };
        case actionTypes.SET_LOCK_USER:
            // Updates project lock user and resets edit mode to default
            const tenantEditMode = getTenantEditMode();
            return {
                ...state,
                currentLockUser: action.payload,
                editMode: tenantEditMode,
                editEnabled: handleEditMode(tenantEditMode)
            };
        case actionTypes.SET_EDIT_ENABLED:
            return {
                ...state,
                editMode: action.payload
                    ? state.editMode
                    : PROJECT_EDIT_MODES.DISABLED,
                editEnabled: {
                    overview: action.payload,
                    question: action.payload,
                    audience: action.payload,
                    settings: action.payload
                }
            };

        case actionType.CLEAR_PROJECT:
        case actionType.CLEAR_STATE:
            return {
                ...initialState
            };
        default:
            return state;
    }
}
